import styled from '@emotion/styled';
import { themeVars } from '@eds-web/react';

export const StyledTaxProfile = styled.div`
    display: flex;
    flex-direction: column;

    a {
        color: ${themeVars.color.palette.blue['500']};
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    p {
        color: ${themeVars.color.transparent.light['065']};
        line-height: 1.5;
    }

    .profile-header {
        gap: 16px;
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
    }

    .profile-body {
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .profile-form {
        gap: 24px;
    }

    .form-column {
        display: flex;
        gap: 20px;

        & > div {
            flex: 1;
        }

        .empty-class {
            visibility: hidden;
        }
    }

    .region-state-content {
        display: flex;
        gap: 20px;

        & > div {
            flex: 1;
        }
    }
`;
